import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
} from "@mui/material";

const CategoryTable = ({ data, checkType }) => {
  const totalPrice = data.reduce(
    (acc, category) => acc + parseInt(category.price, 10),
    0
  );

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            {data.length > 0 ? (
              <TableCell colSpan={5}>
                {data[0].location === "Ачигдсан" ? (
                  <Box className="text-[orange]">
                    <Typography
                      style={{ font: "bold 14px Tahoma", color: "orange" }}
                    >
                      <strong>
                        Таны {data.length} ширхэг ачаа ачигдсан байна.{" "}
                        <Box
                          style={{
                            marginTop: 5,
                            font: "normal 14px Tahoma",
                            color: data[0].shipment === "1" ? "blue" : "green",
                          }}
                        >
                          (
                          {data[0].shipment === "1"
                            ? "Шуурхай ачилтаар"
                            : "Энгийн ачилтаар"}
                          )
                        </Box>
                      </strong>
                    </Typography>
                  </Box>
                ) : (
                  <Typography
                    style={{ font: "bold 14px Tahoma", color: "green" }}
                  >
                    <strong>Танд {data.length} ширхэг ачаа ирсэн байна.</strong>
                  </Typography>
                )}
              </TableCell>
            ) : checkType === 1 ? (
              <TableCell colSpan={5}>
                <Typography style={{ font: "bold 14px Tahoma", color: "red" }}>
                  <strong>Танд ачаа ирээгүй байна.</strong>
                </Typography>
              </TableCell>
            ) : null}
          </TableRow>
        </TableHead>

        <TableBody>
          {data.map((category, index) => (
            <TableRow key={index}>
              <TableCell>
                <Typography style={{ width: 5, font: "bold 14px Tahoma" }}>
                  Код:
                </Typography>
              </TableCell>
              <TableCell colSpan={1}>
                <Typography style={{ font: "bold 14px Tahoma" }}>
                  {category.name}
                </Typography>
              </TableCell>
              <TableCell colSpan={1}>
                <Typography style={{ font: "bold 14px Tahoma" }}>
                  {category.price}₮
                </Typography>
              </TableCell>
              <TableCell colSpan={1}>
                <Typography style={{ font: "normal 14px Tahoma" }}>
                  {category.location === "Ачигдсан"
                    ? "Ачигдсан"
                    : `${category.branchName}`}
                </Typography>
                <Typography style={{ font: "bold 14px Tahoma" }}>
                  <span style={{ font: "normal 14px Tahoma", color: "green" }}>
                    ({new Date(category.updatedAt).toLocaleDateString()})
                  </span>
                </Typography>
              </TableCell>
            </TableRow>
          ))}

          {data.length > 1 && (
            <TableRow>
              <TableCell colSpan={5}>
                <Typography style={{ font: "bold 14px Tahoma" }}>
                  Нийлбэр дүн: {totalPrice.toLocaleString("mn-MN")} ₮
                </Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default CategoryTable;
